import {TrustArc} from "./lib/trust-arc";
import {GtmHandler} from "./lib/gtm-handler";
import {runAfterDOMLoaded} from "./helpers/document-helper";

export class TrustArcAndGtm {

    static scriptInit() {
        window.dataLayer = window.dataLayer || [];
        window.idcGtm = {
            isFirstVisit: true
        };
        runAfterDOMLoaded(() => TrustArcAndGtm.initTrustArcAndGTM());
    }

    static initTrustArcAndGTM() {
        if (TrustArc.trustArcEnabled()) {
            if (TrustArc.trustArcCookiesExist()) {
                // this is not a first visit, so we can load trustarc and gtm right away in parallel
                window.idcGtm.isFirstVisit = false;
                TrustArc.loadTrustArcScript().then();
                GtmHandler.loadGtmScript();
            } else {
                // this is a first visit, so we need to wait to load GTM - it is dependent on TrustArc
                TrustArc.loadTrustArcScript()
                    .then(() => GtmHandler.loadGtmScript());
            }
        }
    }
}

TrustArcAndGtm.scriptInit();
GtmHandler.runListeners();
